import {WebsiteModuleController} from "../website-module.controller";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";

export class WebsiteModuleProps extends BaseModuleProps {
  controller: WebsiteModuleController;
  basename: String;
  pushNotificationRequestPermission: Function;
}
